import { useState, useEffect } from 'react';
import { TopToolbar, AutocompleteInput, useRecordContext, ExportButton, Button, List, Datagrid, TextField, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, DateField } from 'react-admin';
import IconAdd from '@mui/icons-material/Add';
import OrderProductModalCreate from "../components/orderProductCreate";
import OrderSupplementModalCreate from "../components/orderSupplementCreate";
import { ProductFamilyText } from "../components/productFamilyText";
// set params when calling the deleteOne callback
import { useDelete } from 'react-admin';

const ListActions = (props) => (
    <TopToolbar>
        <ExportButton/>
    </TopToolbar>
);


const DeleteButton = (props) => {
    var record = useRecordContext();
    const [deleteOne, { isLoading, error }] = useDelete();
    const handleClick = () => {
        deleteOne(
            'orderProducts',
            { id: record.id , previousData: record },
        ).then(() => setTimeout(() => window.location.reload(), 1000));
    }
    if (error) { return <p>ERROR</p>; }
    return <button disabled={isLoading} onClick={handleClick}>Supprimer l'article</button>;
};

export const OrderProductList = (props) => {
    var record = useRecordContext();
    if (!record || !record.products || !record.productsIds || !record.id) return <span>Chargement</span>;
    var products = record.products;
    var productsIds = record.productsIds;
    var orderId = record.id;

    var actions = <ListActions orderId={orderId}/>;

    return (
        <div style={{width: "100%"}}>
            <OrderProductModalCreate />
            <OrderSupplementModalCreate />
            <List exporter={false} bulkActionButtons={false} filter={{ orderId: orderId }} style={{width: "100%"}} resource="orderProducts" basePath="" actions={actions}>
                <Datagrid>
                    <TextField source="productId" label="ID Produit" />
                    <ProductFamilyText label="Catégorie" />
                    
                    <TextField source="product.product" label="Nom du produit" />
                    <TextField source="product.details" label="Détails" />
                    <TextField source="product.price" label="Prix TTC" />

                    <TextField source="count" label="Quantité" />
                    <DeleteButton source="id" label="Actions" />
                </Datagrid>
            </List>
        </div>
    )
};